import { Component, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { InitDetail } from 'lightgallery/lg-events'
import { LightGallerySettings } from 'lightgallery/lg-settings'
import { LightGallery } from 'lightgallery/lightgallery'
import lgZoom from 'lightgallery/plugins/zoom'
import lgVideo from 'lightgallery/plugins/video'

import { Subscription } from 'rxjs'
import { UploadGallaryImagesComponent } from '../../components/upload-gallary-images/upload-gallary-images.component'
import { ActivatedRoute } from '@angular/router'
import { UploadGallaryVideosComponent } from '../../components/upload-gallary-videos/upload-gallary-videos.component'
import { OrganizationsService } from '../../services/organizations.service'
import { environment } from 'src/environments/environment'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { TranslateService } from '@ngx-translate/core'
import { ToastrService } from 'ngx-toastr'
import { Gallery, GalleryFilter } from '../../models/gallery.model'
import { SharedService } from 'src/app/shared/services/shared.service'

@Component({
	selector: 'app-organization-branch-gallery',
	templateUrl: './organization-branch-gallery.component.html',
	styleUrls: ['./organization-branch-gallery.component.scss'],
})
export class OrganizationBranchGalleryComponent implements OnInit {
	selectedMediaType: number | null = null;
	gallery: Gallery[] = [];
	lightGallery!: LightGallery;
	subscription = new Subscription
	settings: LightGallerySettings = {
		counter: false,
		plugins: [lgZoom, lgVideo],
		thumbnail: true,
		animateThumb: true,
	};
	galleryFilter: GalleryFilter = {
		"paging": {
			"pageNumber": 1,
			"pageSize": 9
		},
		"branchId": null,
		"mediaType": null
	}
	imagPath = environment.attachmentPath
	totalCount = 0
	constructor(private dialog: MatDialog, private activeRout: ActivatedRoute,private SharedService: SharedService,
		private organizationsService: OrganizationsService, private toaster: ToastrService, public translate: TranslateService) {
		this.SharedService.handleBreadCrumb('organization_gallery', false, {
			name: '',
			id: null,
			url: '',
			queryParams: null,
		})
	}

	ngAfterViewChecked(): void {
		this.lightGallery.refresh();
	}

	onInit = (detail: InitDetail): void => {
		this.lightGallery = detail.instance;
	};


	ngOnInit(): void {
		this.galleryFilter.branchId =this.activeRout.snapshot.params['branchId']
		this.getGallery()
	}



	getGallery(isScroll: boolean = false) {

		this.galleryFilter.mediaType = this.selectedMediaType
		this.subscription.add(
			this.organizationsService.getGallery(this.galleryFilter).subscribe((res: any) => {
				isScroll ? this.gallery.push(...res.result?.items) : this.gallery = res?.result?.items
				this.totalCount = res?.result?.totalCount
			}))
	}

	deleteMedia(image: any) {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '450px',
				data: {
					notflex: true,
					message: 'CONFIRMATION_MESSAGE.DELETE_MEGIA',
					cancelBtn: 'ACTIONS.CANCEL',
					confirmBtn: 'ACTIONS.YES',
				},

			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.subscription.add(
							this.organizationsService.DeleteFromGallery(image?.id).subscribe((res: any) => {
								this.galleryFilter.paging.pageNumber = 1
								this.getGallery()
								this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
							}))
					}
				},
			})
	}

	uploadImages() {
		this.dialog
			.open(UploadGallaryImagesComponent, {
				width: '752px',
				height: '70vh',
				panelClass: 'overflow-y-auto',
				disableClose: true,
				data: { branchId: this.galleryFilter.branchId }

			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					res ? (this.getGallery(), this.galleryFilter.paging.pageNumber = 1) : null
				},
			})
	}

	uploadVideos() {
		this.dialog
			.open(UploadGallaryVideosComponent, {
				width: '752px',
				height: '70vh',
				panelClass: 'overflow-y-auto',
				disableClose: true,
				data: { branchId: this.galleryFilter.branchId }

			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					res ? (this.getGallery(), this.galleryFilter.paging.pageNumber = 1) : null
				},
			})
	}
	onScrollDown(event: any) {
		if (this.totalCount > this.gallery?.length && document.body.offsetHeight - 500 <= event?.currentScrollPosition) {
			this.galleryFilter.paging.pageNumber++;
			this.getGallery(true)
		}

	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
